// --- store.js (converted, no tron, using Redux Toolkit) ---
import { configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import { initializeAbilityWatcher } from '../services/permissions/updater'

import RootEffects from './sagas';
import RootReducers from './reducers';

// --- saga middleware
const sagaMiddleware = createSagaMiddleware();

// --- configure store
export const store = configureStore({
  reducer: RootReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: false,
    }).concat(sagaMiddleware),
  devTools: process.env.NODE_ENV === 'development',
});

export const persistor = persistStore(store);

initializeAbilityWatcher(store)

// --- run effects
sagaMiddleware.run(RootEffects);
